var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-col w-full border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid flex justify-between flex items-center"},[_c('div',{staticClass:"flex flex-col"},[_c('h5',{staticClass:"mb-1 text-primary",staticStyle:{"font-weight":"600"}},[_vm._v(_vm._s(_vm.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }